document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const meadowId = urlParams.get("meadow_id");
  const packageType = urlParams.get("package");

  // Store in session storage to persist during session
  if (meadowId) {
    sessionStorage.setItem("meadow_id", meadowId);
  }
  if (packageType) {
    sessionStorage.setItem("package_type", packageType);
  }

  const storedMeadowId = sessionStorage.getItem("meadow_id");
  const storedpackageType = sessionStorage.getItem("package_type");
  
  if (storedMeadowId || storedpackageType) {
    console.log("Meadow ID stored in session:", storedMeadowId);
    console.log("Package type stored in session:", storedpackageType);
    
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log("Fetched cart.js");
        console.log(cart);
        
        const updates = {};
        
        // Add meadow_id to cart attributes if available
        if (storedMeadowId || storedpackageType) {
          updates.attributes = {};
          if (storedMeadowId) {
            updates.attributes.meadow_id = storedMeadowId;
          }
          if (storedpackageType) {
            updates.attributes.package = storedpackageType;
          }
        }

        // Handle discount based on package type
        if (storedpackageType === "signature") {
          updates.discount = "MEADOWSIGNATURE";
        } else if (storedpackageType === "basic") {
          updates.discount = "MEADOWBASIC";
        }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updates),
        });
      })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response from /cart/update.js:");
        console.log(data);
      })
      .catch((error) => console.error("Error updating cart:", error));
  } else {
    console.log("No Meadow ID or package type found.");
  }
});
